import React from "react"
import { Row, Col, Image } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { WhatsappIconSolid } from "../components/icons/icons";
function HeaderTop() {

    return (
        <Row className="App-header px-0">
            <Col className="px-md-5 px-xl-2">
                <Row className="top-header p-2 text-white">
                    <Col className="">
                        <div className="scroller">
                            <span>
                                Welcome to{" "}
                                {/* <Image src={`${process.env.REACT_APP_IMAGE_URL}/front/text-logo.png`} alt="Logo" /> */}
                                Grace
                                <br />
                                An Iconic Destination for Grocery Shopping in Wholesale Prices
                                <br />
                            </span>
                        </div>
                    </Col>
                    <Col xs md="4" className="text-end">
                        <span className="rhInfo">
                            <FontAwesomeIcon icon="fa-solid fa-phone" />
                            &nbsp;&nbsp;6033360333 &nbsp;&nbsp;&nbsp;
                            <WhatsappIconSolid />
                            &nbsp;&nbsp;WhatsApp us!
                        </span>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
}

export default HeaderTop;